var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgCheckFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.55341 12.6898C10.3664 12.6898 12.6469 10.4094 12.6469 7.59637C12.6469 4.78334 10.3664 2.50293 7.55341 2.50293C4.74037 2.50293 2.45996 4.78334 2.45996 7.59637C2.45996 10.4094 4.74037 12.6898 7.55341 12.6898ZM6.97895 9.86877L7.17115 10.061L7.311 9.82789L9.85772 5.58336C9.91802 5.48285 9.88543 5.35249 9.78493 5.29218C9.68442 5.23188 9.55406 5.26447 9.49375 5.36498L7.08688 9.37643L5.58127 7.87082C5.49839 7.78794 5.36401 7.78794 5.28113 7.87082C5.19825 7.9537 5.19825 8.08808 5.28113 8.17096L6.97895 9.86877Z",
    fill: "white"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/check-filled.bdf78577186c3f015e7f429455622fdf.svg";